import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import cn from 'classnames';
import { prefix, splitBsPropsAndOmit, bsClass } from './utils/bootstrapUtils';
import PanelCollapse from './PanelCollapse';
import { PanelContext } from '../Panel/PanelContext';
class PanelBody extends React.Component {
  render() {
    const {
      children,
      className,
      collapsible = false
    } = this.props;
    const {
      bsClass: _bsClass
    } = this.context || {};
    const [bsProps, elementProps] = splitBsPropsAndOmit(this.props, ['collapsible']);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    let body = /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
      className: cn(className, prefix(bsProps, 'body'))
    }), children);
    if (collapsible) {
      body = /*#__PURE__*/_jsx(PanelCollapse, {}, void 0, body);
    }
    return body;
  }
}
PanelBody.contextType = PanelContext;
export default bsClass('panel', PanelBody);